import FinancialView from '@/views/financial/FinancialView.vue';

import commissionManager from '@/views/financial/commissionManager';
import indicatedManager from '@/views/financial/indicatedManager';

import filterStorageMixin from '@/mixins/filterStorage.mixin';
import loadingMixin from '@/mixins/loadingView.mixin';

import store from '@/stores';
import { promoterDetailsBeforeEnter } from '@/router/middlewares/promoterDetailsAccess';
import { screen } from '@/router/screenRoutes';

const SUPER_ROLE_ID = 6;
const COMMERCIAL_ROLE_ID = 11;

const superOrCommercial = (to, from, next) => {
  const roles = store.state.user.userInfo.roles_ids || [];

  if (roles.includes(SUPER_ROLE_ID) || roles.includes(COMMERCIAL_ROLE_ID)) next();
  else next({ name: from.name });
};

const commonMixins = [
  filterStorageMixin,
  loadingMixin,
];

const commissionComponentConfig = {
  component: {
    ...FinancialView,
    mixins: [
      ...commonMixins,
      commissionManager,
    ],
  },
};

const indicatedComponentConfig = {
  component: {
    ...FinancialView,
    mixins: [
      ...commonMixins,
      indicatedManager,
    ],
  },
};

export default [
  // routes
  {
    ...screen('promoters-commission'),
    ...commissionComponentConfig,
  },
  {
    ...screen('promoters-commission-details'),
    ...commissionComponentConfig,
    props: true,
  },
  {
    ...screen('promoters-commission-indicated'),
    ...indicatedComponentConfig,
  },
  {
    ...screen('promoters-commission-indicated-details'),
    ...indicatedComponentConfig,
    props: true,
  },
  {
    ...screen('promoters-goals'),
    component: () => import('@/views/Goals.vue'),
    props: true,
  },
  {
    ...screen('promoters-goals-edit'),
    component: () => import('@/views/Goals.vue'),
    props: true,
  },
  {
    ...screen('promoters-bonds'),
    component: () => import('@/views/PromotersBonds.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (to.params.promoterId && to.params.promoterName) next();
      else next({ name: 'promoters' });
    },
  },
  {
    ...screen('promoters'),
    component: () => import('@/views/PromotersList.vue'),
    props: true,
  },
  {
    ...screen('promoters-edit'),
    component: () => import('@/views/PromotersEdit.vue'),
    props: true,
  },
  {
    ...screen('promoters-details'),
    component: () => import('@/views/PromotersDetails.vue'),
    beforeEnter: promoterDetailsBeforeEnter,
    props: true,
  },
  {
    ...screen('promoters-commercial-agenda'),
    component: () => import('@/views/CommercialAgenda.vue'),
    beforeEnter: superOrCommercial,
  },
  {
    ...screen('promoters-bonds-details'),
    component: () => import('@/views/BondsDetails.vue'),
  },

  // redirects (legacy)
  {
    path: '/usuarios/promotores/:id',
    redirect: { name: 'promoters-edit' },
  },
  {
    path: '/comissoes',
    redirect: { name: 'promoters-commission' },
  },
  {
    path: '/comissoes/:id',
    redirect: { name: 'promoters-commission-details' },
  },
  {
    path: '/metas',
    redirect: { name: 'promoters-goals' },
  },
  {
    path: '/metas/:id',
    redirect: { name: 'promoters-goals-edit' },
  },
];
